import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TransitProgram, TransitProgramInfo, TransitProgramService } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';
import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'uz-transit-program-select',
  templateUrl: './transit-program-select.component.html',
  styleUrls: ['./transit-program-select.component.scss']
})
export class TransitProgramSelectComponent implements OnInit, OnChanges {
  @Input() value: TransitProgramInfo | Array<TransitProgramInfo | number>;
  @Input() allowMultiSelect = false;

  @Output() selectTransitProgram = new EventEmitter<Array<TransitProgramInfo>>();

  transitPrograms: Array<TransitProgramInfo>;
  filteredTransitPrograms = new ReplaySubject<Array<TransitProgramInfo>>(1);
  transitProgramSelector = new UntypedFormControl();
  transitProgramFiltersControl = new UntypedFormControl();

  constructor(private transitProgramService: TransitProgramService) {}

  ngOnInit() {
    this.transitProgramService.listAllTransitPrograms(0, 1000).subscribe(transitPrograms => {
      this.transitPrograms = transitPrograms;
      this.filteredTransitPrograms.next(this.transitPrograms.slice());
      this.mergeTransitProgramValues();
    });

    this.transitProgramFiltersControl.valueChanges.subscribe(() => {
      this.filterTransitPrograms();
    });

    this.transitProgramSelector.valueChanges.pipe(filter(value => !isNullOrUndefined(value))).subscribe(changes => {
      this.selectTransitProgram.emit(changes);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['transitProgram'] && changes['transitProgram'].currentValue) {
      this.mergeTransitProgramValues();
    }
  }

  compareIds(o1: any, o2: any): boolean {
    if (isNullOrUndefined(o1) || isNullOrUndefined(o2)) {
      return false;
    }
    return o1.id === o2.id;
  }

  private mergeTransitProgramValues() {
    if (isNullOrUndefined(this.value)) {
      this.transitProgramSelector.reset();
    } else {
      if (!this.allowMultiSelect) {
        this.transitProgramSelector.reset();
      } else {
        // TODO: maybe a better way than this hack?
        const valueAsArray = this.value as Array<TransitProgram | number>; // value is now assumed to be an array
        if (valueAsArray[0] instanceof TransitProgram) {
          this.transitProgramSelector.setValue(valueAsArray, { onlySelf: true, emitEvent: false });
        } else {
          if (!isNullOrUndefined(this.transitPrograms)) {
            this.transitProgramSelector.setValue(
              this.transitPrograms.filter(tp => valueAsArray.includes(tp.id)),
              { onlySelf: true, emitEvent: false }
            );
          }
        }
      }
    }
  }

  private filterTransitPrograms() {
    if (!this.transitPrograms) {
      return;
    }
    // get the search keyword
    let search = this.transitProgramFiltersControl.value;
    if (!search) {
      this.filteredTransitPrograms.next(this.transitPrograms.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the transitPrograms
    this.filteredTransitPrograms.next(
      this.transitPrograms.filter(
        transitProgram => (transitProgram.code.toLocaleLowerCase() + transitProgram.name.toLowerCase()).indexOf(search) > -1
      )
    );
  }
}
